import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export class ApInitialsValidator {
    public static validate(control: AbstractControl): ValidationErrors {
        return Validators.compose([Validators.pattern(/^(?!.*\.{2})[A-Z.\s]+$/i)])(control);
    }
}
